import angular from 'angular';

class folderRetryValidationCtrl {
  constructor() {}

  $onInit() {
    // this.container = angular.copy(this.resolve.container);
    this.containerTitle = this.resolve.containerTitle;
    this.container = this.resolve.container;
    this.endContainer = this.resolve.endContainer;
    this.closeAppear = this.resolve.closeAppear;
  }

  close() {
    this.modalInstance.dismiss();
  }
}

angular.module('dashboard').component('folderRetryValidation', {
  templateUrl: require('./folder-retry-validation-popup.html'),
  controller: folderRetryValidationCtrl,
  bindings: {
    resolve: '<',
    modalInstance: '<'
  }
});
